import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { Observable, forkJoin, map, of } from "rxjs";

export class CustomTranslationLoader implements TranslateLoader {
    constructor(private http: HttpClient) {}
    getTranslation(lang: string): Observable<any> {
        const date = new Date().toISOString().split('T')[0];
        return forkJoin(of([])).pipe(
            map((res: any) => {
                const result = {};
                for (let i = 0; i < res.length; i++) {
                    this.addKeysToResult(result, res[i]);
                }
                return result;
            })
        )
    }

    addKeysToResult(result: any, res: any): any {
        Object.keys(res).forEach(key => {
            result[key] = res[key];
        });
    }
}
